import { Component, effect, ElementRef, inject, input, ViewChild } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { ScriptService } from '../../../../features/services/script.service';
import { TrustPilot } from '../gg-footer.component';

@Component({
  selector: 'app-gg-trustpilot',
  templateUrl: './gg-trustpilot.component.html',
  styleUrls: ['./gg-trustpilot.component.scss'],
  standalone: false,
})
export class GgTrustpilotComponent {
  @ViewChild('trustbox') trustbox: ElementRef | undefined;
  trustpilot = input.required<TrustPilot>();

  winRef = inject(WindowRef);
  scriptService = inject(ScriptService);

  loadTrustpilot = effect(() =>
    this.scriptService.loadScript('trustpilot').then((result) => {
      if (result.loaded) {
        this.winRef.nativeWindow?.['Trustpilot']?.loadFromElement(this.trustbox?.nativeElement);
      }
    })
  );
}
